import * as React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import type { UiBaseProps } from "../uiProps.utils";

export type ProgressBarProps = Omit<UiBaseProps, "children"> & {
  // 0–100 fills the bar that far; without it the bar runs continuously.
  value?: number;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({ value, ...rest }) =>
  value === undefined ? <LinearProgress {...rest} /> : <LinearProgress variant="determinate" value={value} {...rest} />;
